import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { FileUpload, FileUploadHeaderTemplateOptions, FileUploadSelectEvent, ItemTemplateOptions } from "primereact/fileupload";
import { Tag } from "primereact/tag";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import DocumentoVersaoService from "service/documentos/DocumentoVersaoService";
import GoogleDriveService from "service/GoogleDriveService";

type Props = {
    visible: boolean;
    onHide: () => void;
    idVersao: number;
    onConfirm: (url: string) => void;
}

const documentoVersaoService = new DocumentoVersaoService();
const googleDriveService = new GoogleDriveService();
export default function ModalCriarDocumentoOnline(props: Props) {

    const { msgAlerta, msgSucesso, msgErro } = useToastContext();
    const [acessoDrive, setAcessoDrive] = useState<boolean>(false);

    const { startLoading, stopLoading } = useLoadingContext();
    const [anexo, setAnexo] = useState<File | null>(null);

    const [tipoSelecionado, setTipoSelecionado] = useState<string>("DOC");
    const tipos = [
        { label: "Documento", value: "DOC", icon: "pi-file-word" },
        { label: "Planilha", value: "XLS", icon: "pi-file-excel" },
    ]

    const opcoesCriacao = [
        { label: "Criar documento vazio", value: "CRIAR" },
        { label: "Copiar documento vigente", value: "COPIAR_VIGENTE" },
        { label: "Carregar documento", value: "CARREGAR_DOCUMENTO" },
    ]
    const [opcaoCriacao, setOpcaoCriacao] = useState<string>(opcoesCriacao[0].value);

    useEffect(() => {
        validarAcessoDrive();
    }, []);

    function validarAcessoDrive() {
        console.log("validando acesso")
        startLoading();
        googleDriveService.validarAcesso().then(acessoValido => {
            stopLoading();
            setAcessoDrive(acessoValido);
        }).catch(err => {
            stopLoading();
            console.error("Erro ao validar acesso ao Google Drive:", err);
            msgErro("Erro ao validar acesso ao Google Drive", "");
        });
    }

    function handleConfirm() {
        startLoading();

        if (opcaoCriacao === "CARREGAR_DOCUMENTO") {
            if (!anexo) {
                stopLoading();
                msgAlerta("Selecione um documento para carregar", "");
                return;
            }
            documentoVersaoService.carregarDocumentoOnline({ idVersao: props.idVersao, arquivo: anexo })
                .then((url) => {
                    stopLoading();
                    msgSucesso("Documento criado com sucesso!", "");
                    props.onConfirm(url);
                }).catch((err) => {
                    stopLoading();
                    msgErro("Erro ao criar documento online", err.data.message || "");
                })
            return;
        }
        documentoVersaoService.criarDocumentoOnline({ idVersao: props.idVersao, tipo: tipoSelecionado, opcao: opcaoCriacao })
            .then((url) => {
                stopLoading();
                msgSucesso("Documento criado com sucesso!", "");
                props.onConfirm(url);
            }).catch((err) => {
                stopLoading();
                msgErro("Erro ao criar documento online", err.data.message || "");
            })
    }

    const openGooglePopup = () => {
        const width = 500;
        const height = 600;
        const left = window.innerWidth / 2 - width / 2;
        const top = window.innerHeight / 2 - height / 2;

        const popup = window.open(
            'https://accounts.google.com/o/oauth2/v2/auth?' +
            new URLSearchParams({
                client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
                redirect_uri: window.location.origin + '/driveCallback',
                response_type: 'code',
                scope: 'https://www.googleapis.com/auth/drive.file',
                access_type: 'offline',
                prompt: 'consent'
            }).toString(),
            'Google Login',
            `width=${width},height=${height},top=${top},left=${left}`
        );

        const popupCheckInterval = setInterval(() => {
            if (!popup || popup.closed) {
                clearInterval(popupCheckInterval);
                validarAcessoDrive();
            }
        }, 500);
    };

    const headerTemplate = (options: FileUploadHeaderTemplateOptions) => {
        const { className, chooseButton } = options;

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                Arraste e solte o arquivo aqui
            </span>
        );
    };

    const itemTemplate = (file: object, options: ItemTemplateOptions) => {
        let localFile = file as File;
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", padding: '0.5rem' }}>
                {localFile.name}
                <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={() => onTemplateRemove(localFile, options.onRemove)} />
            </div>
        );
    };

    const onTemplateRemove = (file: File, callback: Function) => {
        setAnexo(null);
        callback();
    };

    function onUploadAnexo(event: FileUploadSelectEvent) {
        try {
            if (event.files && event.files.length) {
                setAnexo(event.files[0]);
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (

        <Dialog
            header="Criar Documento Online"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: window.innerWidth < 500 ? window.innerWidth : window.innerWidth - 500 }}
            onHide={props.onHide}
            footer={<>
                <Button label="Fechar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Criar" disabled={!acessoDrive} icon="pi pi-check" onClick={() => handleConfirm()} />
            </>}
        >
            {!acessoDrive ? <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <span>Você precisa conectar sua conta do Google Drive para realizar essa operação</span>
                <Button label="Conectar ao Google Drive" icon="pi pi-google" className="p-button-outlined p-button-danger" onClick={openGooglePopup} />
            </div> : <>
                <Label label="Criação" />
                <Dropdown
                    style={{ width: '100%' }}
                    options={opcoesCriacao}
                    optionLabel="label"
                    optionValue="value"
                    value={opcaoCriacao}
                    onChange={(e) => setOpcaoCriacao(e.value)}
                    itemTemplate={(option) => {
                        return (
                            <div className="p-d-flex p-ai-center">
                                <i className={`pi ${option.icon}`} />
                                <span style={{ marginLeft: 5 }}>{option.label}</span>
                            </div>
                        )
                    }}
                />
                {opcaoCriacao !== "CARREGAR_DOCUMENTO" ? <div>
                    <Label label="Tipo" />
                    <Dropdown
                        style={{ width: '100%' }}
                        options={tipos}
                        optionLabel="label"
                        optionValue="value"
                        value={tipoSelecionado}
                        onChange={(e) => setTipoSelecionado(e.value)}
                        itemTemplate={(option) => {
                            return (
                                <div className="p-d-flex p-ai-center">
                                    <i className={`pi ${option.icon}`} />
                                    <span style={{ marginLeft: 5 }}>{option.label}</span>
                                </div>
                            )
                        }}
                    />
                </div> : null}
                {opcaoCriacao === "CARREGAR_DOCUMENTO" ? <div>
                    <FileUpload
                        multiple={false}
                        itemTemplate={itemTemplate}
                        headerTemplate={headerTemplate}
                        progressBarTemplate={() => { return null }}
                        onSelect={(event) => onUploadAnexo(event)}
                        accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.ms-excel"
                        chooseLabel="Escolher"
                        uploadLabel="Trocar arquivo"
                        cancelLabel="Cancelar"
                        emptyTemplate={emptyTemplate} />
                </div> : null}
            </>}
        </Dialog>
    );
}